import React from 'react';
import { ArrowTopRightOnSquareIcon, UserPlusIcon } from '@heroicons/react/24/outline';

type TenantQuickActionsProps = {
  onViewDetail: () => void;
  onCreateAdmin: () => void;
};

export const TenantQuickActions: React.FC<TenantQuickActionsProps> = ({
  onViewDetail,
  onCreateAdmin
}) => (
  <div className="flex shrink-0 items-center justify-end gap-2 border-t border-slate-100 pt-3 sm:border-t-0 sm:pt-0">
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onViewDetail();
      }}
      className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-700 shadow-sm transition-all hover:border-slate-300 hover:bg-slate-50"
    >
      <ArrowTopRightOnSquareIcon className="h-4 w-4" aria-hidden />
      Ver detalle
    </button>
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onCreateAdmin();
      }}
      className="inline-flex items-center gap-1.5 rounded-lg bg-slate-900 px-3 py-2 text-xs font-semibold text-white shadow-sm transition-all hover:bg-slate-800"
    >
      <UserPlusIcon className="h-4 w-4" aria-hidden />
      Admin
    </button>
  </div>
);
